import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSetAtom } from 'jotai'
import { setCreditQueue, setSelectedWallet, setUserData } from 'redux-thunk/redux/slices/user.slice'
import { fetchUserInformation } from 'redux-thunk/thunk/user.thunk'
import useWalletSocketNameSpace from 'socket-resources/hooks/useWalletSocketNameSpace'
import { walletBalanceAtom } from 'store/wallet.atom'
import { useBalanceSync } from 'hooks/useBalanceSync'
import CurrencyDropdown from '../CurrencyDropdown/index'
import { minus } from 'number-precision'

const WalletSubscription = (props) => {
  const { listenWalletUpdateEvent } = useWalletSocketNameSpace()
  const dispatch = useDispatch()
  const { user, selectedWallet, creditQueue } = useSelector((state) => state.user)
  const { loginData } = useSelector((state) => state.auth)
  const setWalletBalance = useSetAtom(walletBalanceAtom)

  const [updatedWalletData, setUpdatedWalletData] = useState(null)

  // Global 10-second polling + manual refresh
  const { refreshBalance } = useBalanceSync()

  const handleWalletUpdate = (data) => {
    setUpdatedWalletData(data?.data)
    // Schedule a confirmatory poll shortly after socket push to ensure DB is consistent
    setTimeout(() => refreshBalance(), 2000)
  }

  useEffect(() => {
    if (loginData?.accessToken) {
      dispatch(fetchUserInformation())
      const cleaner = listenWalletUpdateEvent(handleWalletUpdate)
      return () => cleaner()
    }
  }, [loginData?.accessToken])

  useEffect(() => {
    if (!updatedWalletData) return

    const userWalletData = user?.wallets
    const updatedUserWalletData = userWalletData?.map(ele => {
      if (ele.id === updatedWalletData.id) {
        return { ...ele, amount: updatedWalletData.amount, nonCashAmount: updatedWalletData.nonCashAmount }
      }
      return ele
    })

    if (selectedWallet?.currencyId === updatedWalletData?.currencyId) {
      let nextWallet

      if (updatedWalletData?.type === 'debit') {
        const updatedAmount = creditQueue?.length > 0
          ? minus(+selectedWallet.amount, +updatedWalletData?.betInfo?.betAmount)
          : updatedWalletData.amount
        nextWallet = { ...selectedWallet, amount: +updatedAmount, nonCashAmount: updatedWalletData.nonCashAmount }
        dispatch(setSelectedWallet(nextWallet))
      } else if (updatedWalletData?.type === 'credit') {
        dispatch(setCreditQueue({ ...updatedWalletData }))
        nextWallet = { ...selectedWallet, amount: updatedWalletData.amount, nonCashAmount: updatedWalletData.nonCashAmount }
      } else {
        nextWallet = { ...selectedWallet, amount: updatedWalletData.amount, nonCashAmount: updatedWalletData.nonCashAmount }
        dispatch(setSelectedWallet(nextWallet))
      }

      // Keep Jotai atom in sync with socket events too
      if (nextWallet) setWalletBalance(nextWallet)
    }

    dispatch(setUserData({ ...user, wallets: updatedUserWalletData }))
  }, [updatedWalletData])

  return <CurrencyDropdown {...props} />
}

export default WalletSubscription
